// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "modules/" + chunkId + "-b1-" + {"87":"f80e081322a3e26ae90b","481":"560133b218a881c6c21c","620":"4c9bcd5cbf48a102a4ab","847":"ba335cb105557f8541b2","880":"bb247f996fac603fe7b7","881":"5c7c4c05622faee4f90c"}[chunkId] + ".js";
};